import store from "@/store/index.js";

export default {
  methods: {
    formatPath(path) {
      return path.replace("/pages", "").replace("index", "")
    },
    setHref(link) {
      if (link.linktype === "url") {
        return link.url;
      } else {
        return this.formatPath(link.cached_url);
      }
    },
    getStoryblokLink(link, blank, anchor) {
      store.commit("SET_SIDEBAR_STATUS", false);
      console.log(typeof link)
      if(typeof link === "string") {
        
        blank ? window.open(link, "_blank") : (window.location = link);
      }
      if (link.linktype === "url") {
        blank ? window.open(link.url, "_blank") : (window.location = link.url);
      } else {
        var path = link.cached_url.replace("/pages", "").replace("index", "")
        var hash = "#" + anchor

        if (anchor === undefined || anchor === '') {
          this.$router.push({ path })
        }
        else {
          console.log(hash)
          path += '/' + hash
          this.$router.push({
            path
          }, () => {
            setTimeout(() => {
              location.href = this.$route.hash
            }, 1)
          });
        }
      }
    }
  }
};
